module.exports = __webpack_public_path__ + "img/750-2.1fbd1226.png";